import "./styles.css";

export default function App() {
  return (
    <div className="container">
      <div className="img_div">
        <img
          src="https://images.unsplash.com/photo-1506102383123-c8ef1e872756?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MTN8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
          alt="img"
        />
      </div>
      <div className="centered-element">
        <div>
          <p className="para_text">Login To Explore</p>
        </div>
        <div>
          <input />
          <input />
        </div>
        <div>
          <button>Login</button>
        </div>
      </div>
    </div>
  );
}
